export default __webpack_public_path__ + "static/media/calendar_active.de2f5288.svg";